// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2WMxI","legacyBtn":"MutateMid_legacyBtn__3otFz"};